import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
var myChart, timer;
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    tableName: {
      type: String,
      default: '水质分布'
    },
    top: {
      type: String,
      default: '-36px'
    },
    left: {
      type: String,
      default: '-130px'
    }
  },
  data: function data() {
    return {
      chart: 'chart9'
    };
  },
  methods: {
    initBarChart: function initBarChart(chartData) {
      var colorList = [new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        offset: 0,
        color: "#CA8CCA"
      }, {
        offset: 1,
        color: "#EFA5BB"
      }]), new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        offset: 0,
        color: "#BFA4E4"
      }, {
        offset: 1,
        color: "#E29CE2"
      }]), new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        offset: 0,
        color: "#A8AAE5"
      }, {
        offset: 1,
        color: "#BEA3E3"
      }]), new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        offset: 0,
        color: "#A4D37D"
      }, {
        offset: 1,
        color: "#E5F2A7"
      }])];
      var sum = chartData.reduce(function (per, cur) {
        return per + cur.value;
      }, 0);
      var gap = 1 * sum / 100;
      var pieData1 = [];
      var pieData2 = [];
      var gapData = {
        name: "",
        value: gap,
        itemStyle: {
          color: "transparent"
        }
      };

      for (var i = 0; i < chartData.length; i++) {
        pieData1.push(_objectSpread(_objectSpread({}, chartData[i]), {}, {
          itemStyle: {
            borderRadius: 100,
            shadowColor: "#2a2a34",
            shadowBlur: 5,
            shadowOffsetY: 0,
            shadowOffsetX: 0,
            borderColor: "#2a2a34",
            borderWidth: 2
          }
        }));
        pieData1.push(gapData);
        pieData2.push(_objectSpread(_objectSpread({}, chartData[i]), {}, {
          itemStyle: {
            borderRadius: 10,
            color: colorList[i],
            opacity: 0.1,
            shadowColor: "#000",
            shadowBlur: 1,
            shadowOffsetY: 5,
            shadowOffsetX: 0
          }
        }));
        pieData2.push(gapData);
      }

      var option = {
        title: [{
          text: "站点类型",
          x: "78%",
          y: "45%",
          textAlign: "center",
          textStyle: {
            fontSize: "20",
            fontWeight: "500",
            color: "#98b5d2",
            textAlign: "center",
            textShadowColor: "#000",
            textShadowBlur: "1",
            textShadowOffsetX: 2,
            textShadowOffsetY: 2
          }
        }],
        legend: {
          left: "10%",
          top: "15%",
          align: "left",
          itemGap: 18,
          itemWidth: 20,
          itemHeight: 20,
          shadowBlur: 10,
          shadowOffsetY: 0,
          shadowOffsetX: 0,
          textStyle: {
            color: "#D8DDE3",
            rich: {
              name: {
                verticalAlign: "right",
                align: "left",
                fontSize: 14,
                color: "#D8DDE3"
              },
              percent: {
                padding: [0, 0, 0, 10],
                color: "#D8DDE3",
                fontSize: 14
              }
            }
          },
          formatter: function formatter(name) {
            var item = chartData.find(function (i) {
              return i.name === name;
            });
            return "{name|" + name + "}" + "{percent|" + item.value + "}" + " 个";
          }
        },
        color: colorList,
        series: [{
          type: "pie",
          z: 3,
          roundCap: true,
          radius: ["44%", "51%"],
          center: ["80%", "50%"],
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          data: pieData1
        }, {
          type: "pie",
          z: 2,
          radius: ["40%", "55%"],
          center: ["80%", "50%"],
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          silent: true,
          data: pieData2
        }]
      };
      var chart = this.$refs[this.chart];
      myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};